var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-wrap page-welcome"},[_c('div',{staticClass:"slogan"},[_vm._v("欢迎使用")]),_c('div',{staticClass:"slogan"},[_vm._v("PaaS配置后台")])])
}]

export { render, staticRenderFns }